
import "/app/src/components/Layout/ShellLayout.module.less?modules";
export default {"shell": `shell-FQqxES0Q`,"ant-pro-sider-collapsed": `ant-pro-sider-collapsed-iuYGftPD`,"action": `action-JwvfktLi`}
